<template>
  <div>
    <v-expansion-panel-header class="primary">
      <h4 class="mx-2 mb-0 white--text">{{paymentPage.Title}}</h4>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <div>
        <v-tabs light slider-color="primary" v-model="activePayment">
          <!-- <v-tab class="text-capitalize">Offer Code</v-tab> -->
          <v-tab class="text-capitalize">{{paymentPage.Subtitle}}</v-tab>
          <!-- <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-0">
                <div class="header text-center bg-grey pt-12 pb-4">
                  <div class="mb-6">
                    <img alt="discount" src="/static/images/card.png" />
                  </div>
                  <h4 class="mb-12 font-weight-medium">Enter Card Details</h4>
                </div>
                <v-form class="form-wrapper pt-6 text-center py-12" ref="form" v-model="valid">
                  <div class="layout row wrap">
                    <v-flex xs12 sm12 md12 lg8 xl8>
                      <div class="layout row wrap">
                        <v-flex xs12 sm12 md6 lg10 xl10>
                          <v-text-field
                            class="mt-0 pt-0"
                            :rules="inputRules.basictextRules"
                            light
                            label="Card Number"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg10 xl10>
                          <v-text-field
                            class="mt-0 pt-0"
                            :rules="inputRules.basictextRules"
                            light
                            label="Name"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg3 xl3>
                          <v-text-field
                            class="mt-0 pt-0"
                            :rules="inputRules.basictextRules"
                            light
                            label="CVV"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg3 xl3>
                          <v-text-field
                            class="mt-0 pt-0"
                            :rules="inputRules.basictextRules"
                            light
                            label="Expiry Date(01/10)"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                          <div class="text-xl-left text-sm-left">
                            <v-btn class="accent mr-3" @click="makePayment">Submit</v-btn>
                            <v-btn>Clear</v-btn>
                          </div>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      lg3
                      xl2
                      hidden-md-and-down
                      d-flex
                      justify-center
                      align-center
                      card-visibility
                    >
                      <img
                        src="/static/images/credit-card.png"
                        slt="Credit card"
                        width="128"
                        height="128"
                      />
                    </v-flex>
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>-->
          <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-0">
                <div class="header text-center bg-grey pt-12 pb-4">
                  <div class="mb-6">
                    <img alt="Bank" src="/static/images/online-shop.png" />
                  </div>
                  <h4 class="mb-12 font-weight-medium">{{paymentPage.Area_Caption}}</h4>
                </div>
                <v-divider class="mt-12 mb-2"></v-divider>
                <div class="text-center">
                  <v-container grid-list-lg>
                    <v-layout row wrap>
                      <v-radio-group
                        v-model="selectedPayment"
                        :mandatory="true"
                        row
                        text-center
                        v-on:change="change"
                      >
                        <v-radio
                          v-for="bank in paymentPage.Payment_Methods"
                          :key="bank.ID"
                          :value="bank"
                          class="radio-img"
                        >
                          <template slot="label">
                            <img :src="bank.Image" width="150" height="30" />
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-layout>
                    <v-layout row wrap v-if="isShow" style="display:flex;justify-content:center;">
                      <v-flex xs8 sm4 md2 lg2 v-if="selectedPayment.ID!=3">
                        <v-card-text class="px-0">
                          <v-img alt :src="selectedPayment.QR_Image" aspect-ratio="1" />
                        </v-card-text>
                      </v-flex>
                      <v-flex xs12 sm8 md4 lg4>
                        <v-card-text class="px-0">
                          <p></p>
                          <div v-if="selectedPayment.ID!=3" v-html="selectedPayment.QR_Description"></div>
                          <div v-if="selectedPayment.ID==3">
                            <v-btn
                              class="accent"
                              @click="makeOnLinePayment"
                            >{{paymentPage.Continue_to_Payment}}</v-btn>
                            <!-- <a class="" target="_self" href="https://rzp.io/l/FWghcyX"> </a>   -->
                            <!-- <form>
                              <script
                                type="application/javascript"
                                src="https://rzp.io/l/FWghcyX"
                                data-payment_button_id="pl_FTQPaGYUrK8wE7"
                              ></script>
                            </form>-->
                            <!-- <div class="razorpay-embed-btn" data-url="https://pages.razorpay.com/pl_FVfOQkAtSYi6a1/view" data-text="Pay Now" data-color="#283593" data-size="large">
                                <script type="application/javascript">
                                  (function(){
                                    var d=document; var x=!d.getElementById('razorpay-embed-btn-js');
                                    if(x){ var s=d.createElement('script'); s.defer=!0;s.id='razorpay-embed-btn-js';
                                    s.src='https://cdn.razorpay.com/static/embed_btn/bundle.js';d.body.appendChild(s)} else{var rzp=window['__rzp__'];
                                    rzp && rzp.init && rzp.init()}})();
                                </script>
                            </div>-->
                          </div>
                          <!-- <v-text-field  v-model="paymentPage.QR_Reference_Text"></v-text-field> -->
                        </v-card-text>
                      </v-flex>
                      <!-- <v-flex xs12 sm12 md6 lg6 xl6>
                          <v-flex xs6 sm6 md6 lg6 xl6>
                          <v-img
                            alt=""
                            :src="paymentPage.QR_Image"
                            aspect-ratio="1"
                          />
                           <v-text-field  v-model="paymentPage.QR_Password_Text" :readonly="true"></v-text-field>
                            </v-flex>
                       <v-flex xs6 sm6 md6 lg6 xl6>
                         <p>{{paymentPage.QR_Description}}</p>
                        <v-text-field  v-model="paymentPage.QR_Reference_Text" ></v-text-field>
                         </v-flex>
                      </v-flex>-->
                    </v-layout>
                    <!-- <h6 class="text-left mb-0">All Banks</h6>
                    <div class="layout">
                      <v-flex xs9 sm7 md5 lg5 xl5>
                        <v-select :items="bankListing" class="mt-0 pt-0"></v-select>
                      </v-flex>
                    </div>-->
                    <div
                      v-if="selectedPayment.ID!=3"
                      class="text-left"
                      style="display:flex;justify-content:center;"
                    >
                      <v-btn class="accent" @click="makePayment">{{paymentPage.Make_Payment_Button}}</v-btn>
                    </div>
                  </v-container>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import gettingRestClientObject from "../../../../services/utils/cms-helper";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["stepOneFormValid", "cart"]),
  },
  data() {
    return {
      activePayment: null,
      //   valid: false,
      inputRules: {},
      selectedPayment: "",
      isShow: false,
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.inputRules = {
      basictextRules: [
        (v) => !!v || this.cmsRequestFunctions.getValidationMsgByCode("M026"),
      ],
    };
  },
  props: ["paymentPage"],
  methods: {
    /**
     * This Function is to make Payment
     */
    makePayment() {
      this.$store.dispatch("addPaymentInfo", this.selectedPayment);
      this.$router.push({ path: "/checkout/final-receipt" });
    },
    change: function () {
      var self = this;
      self.selectedPayment.ID !== "1"
        ? (self.isShow = true)
        : (self.isShow = false);
    },
    makeOnLinePayment() {
      this.$store.dispatch("addPaymentInfo", this.selectedPayment);
      // window.location.href = "https://pages.razorpay.com/oneviewecom";
      
    },
  },
};
</script>